import React, { useCallback, useState, useContext } from "react";
import styled, { keyframes } from "styled-components";
import Avatar from "../../SVGs/Avatar.svg";
import EditIcon from "../../SVGs/Edit.svg";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Button, Icon, Modal } from "semantic-ui-react";
import { UserContext } from "../../Context/user_context";
import Cookies from "js-cookie";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import toast from "react-hot-toast";
////
function SideMenu() {
  const navigation = useNavigate();
  const [householdOpen, setHouseholdOpen] = useState(false);
  const [spouseOpen, setSpouseOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [menu, setMenu] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleSignout = useCallback(() => {
    Cookies.remove("hippocratic_portal_contactid");
    Cookies.remove("hippocratic_portal_token");
    setUser(null);
    document.body.style.overflow = "visible";
    navigation("/");
  });

  const handleClick = useCallback(() => {
    setMenu((prevMenu) => {
      const newMenuState = !prevMenu;
      document.body.style.overflow = newMenuState ? "hidden" : "visible";
      return newMenuState;
    });
  }, []);

  const handleSectionClick = useCallback(() => {
    document.body.style.overflow = "visible";
    setMenu(false);
  }, []);

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        // Remove the data:image/...;base64, prefix to get just the base64 string
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleUpdateRecord = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first");
      return;
    }

    setIsLoading(true);
    const userid = Cookies.get("hippocratic_portal_contactid");

    try {
      const base64String = await convertFileToBase64(selectedFile);

      const recordData = {
        entity: "contacts",
        id: userid,
        attributes: [
          {
            fieldname: "hip_profileimage",
            value: base64String,
            type: "string",
            entity: null,
          },
          {
            fieldname: "entityimage",
            value: base64String,
            type: "string",
            entity: null,
          },
        ],
      };
      await getApiClient().updateRecord(recordData);
      toast.success("Profile picture has been updated successfully");
      setUploadModalOpen(false);
      setSelectedFile(null);
      setUser({
        ...user,
        hip_profileimage: base64String,
      });
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <BurgerMenu onClick={handleClick}>
        <Meat />
        <Meat />
        <Meat />
      </BurgerMenu>
      <Container menu={menu}>
        <TopSection to={"/overview"}>
          <AvatarContainer>
            <Image
              src={
                user && user.hip_profileimage
                  ? `data:image/png;base64, ${user.hip_profileimage}`
                  : Avatar
              }
              alt="Avatar"
            />
            <EditIconButton onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setUploadModalOpen(true);
            }}>
              <EditIconImage src={EditIcon} alt="Edit" />
            </EditIconButton>
          </AvatarContainer>
          <NameContainer>
            <Name>{user && user.fullname}</Name>
          </NameContainer>
        </TopSection>
        <BottomSection>
          <Section to="/MyInformation" onClick={handleSectionClick}>
            <Icon name="user circle outline" style={{ marginRight: '10px' }} />
            My Information
          </Section>
          <Section to="/Policies" onClick={handleSectionClick}>
            <Icon name="shield" style={{ marginRight: '10px' }} />
            My Insurance
          </Section>
          <Section to="/WMAccounts" onClick={handleSectionClick}>
            <Icon name="line graph" style={{ marginRight: '10px' }} />
            My Wealth Management Accounts
          </Section>
          <Section to="/DocumentValut" onClick={handleSectionClick}>
            <Icon name="lock" style={{ marginRight: '10px' }} />
            Active Document Vault &trade;
          </Section>
          <Seperator />
          <Section
            to="/Household"
            onClick={() => {
              setHouseholdOpen(!householdOpen);
              handleSectionClick();
            }}
            style={{ fontWeight: "bold", cursor: "pointer" }}
          >
            <Icon name="home" style={{ marginRight: '10px' }} />
            My Household Information
          </Section>
          <InActiveSection onClick={() => setSpouseOpen(!spouseOpen)}>
            <Icon name="heart outline" style={{ marginRight: '10px' }} />
            My Spouse
            <Icon name={spouseOpen ? "chevron up" : "chevron down"} size="small" style={{ marginLeft: 'auto' }} />
          </InActiveSection>
          {spouseOpen && (
            <NestedMenu>
              <NestedSection onClick={handleSectionClick} as={NavLink} to="/spouse-policies">
                <Icon name="shield" style={{ marginRight: '8px' }} />
                View Spouse Insurance Policies
              </NestedSection>
              <NestedSection onClick={handleSectionClick} as={NavLink} to="/spouse-WMAccounts">
                <Icon name="line graph" style={{ marginRight: '8px' }} />
                View Spouse Wealth Management Accounts
              </NestedSection>
            </NestedMenu>
          )}
          <Seperator />
          <Section to="/Security" onClick={handleSectionClick}>
            <Icon name="privacy" style={{ marginRight: '10px' }} />
            Security
          </Section>
          <Seperator />
          <Hide onClick={handleSignout}>
            <Icon name="log out" style={{ marginRight: '10px' }} />
            Signout
          </Hide>
        </BottomSection>
      </Container>
      {menu && <BulrryBackground />}
      <Modal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        size="mini"
      >
        <Modal.Header>Upload Profile Picture</Modal.Header>
        <Modal.Content>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={handleUpdateRecord}
            loading={isLoading}
            disabled={!selectedFile || isLoading}
          >
            Upload
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
  background: var(--darkBlue);
  height: 500px;
  min-width: 310px;
  flex: 0 0 calc(25% - 3rem);
  z-index: 100;

  transition: transform 0.5s ease;

  @media screen and (max-width: 984px) {
    position: absolute;
    right: 0px;
    top: 15vh;
    height: 85vh;
    min-width: 40vw;
    border-radius: 20px 0px 0px 20px;
    transform: ${(props) =>
    props.menu ? "translateX(0%)" : "translateX(100%)"};
  }
`;

const Hide = styled(NavLink)`
  padding: 5px;
  text-decoration: none;
  width: 100%;
  color: var(--white);
  font-family: "Museo Sans Cyrl";
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  border-radius: 2px;
  background-color: none;

  display: none;

  @media screen and (max-width: 984px) {
    display: block;
  }
`;

const TopSection = styled(NavLink)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 25px;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Name = styled.div`
  color: var(--Text-Text-invert, #fff);
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-weight: 400;
  line-height: 25px;
`;

const Status = styled.div`
  color: var(--Text-Text-invert, #fff);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 16px;
`;

const AvatarContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const Image = styled.img`
  width: 80px;
  border-radius: 50px;
`;

const EditIconButton = styled.button`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: var(--white);
  border: 2px solid var(--darkBlue);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: var(--kindaBlue);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const EditIconImage = styled.img`
  width: 16px;
  height: 16px;
`;

const BottomSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 20px 0px;
  gap: 2px;
`;

const Section = styled(NavLink)`
  padding: 5px;
  text-decoration: none;
  width: 100%;
  color: var(--white);
  font-family: "Museo Sans Cyrl";
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  border-radius: 2px;
  background-color: none;

  &.active {
    background-color: var(--kindaBlue);
  }

  &:hover {
    cursor: pointer;
  }
`;

const InActiveSection = styled.div`
  padding: 5px;
  cursor: pointer;
  text-decoration: none;
  width: 100%;
  color: var(--white);
  font-family: "Museo Sans Cyrl";
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  border-radius: 2px;
  background-color: none;

  &.active {
    background-color: var(--kindaBlue);
  }
  &:hover {
    color: blue;
  }
`;

const slideDown = keyframes`
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 100px;
    opacity: 1;
  }
`;

const NestedMenu = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  padding-left: 20px;
  flex-direction: column;
  animation: ${slideDown} 0.3s ease-in-out;
`;

const NestedSection = styled.div`
  color: var(--white);
  font-size: 13px;
  cursor: pointer;
`;

const Seperator = styled.div`
  width: 100%;
  height: 2px;
  background-color: #87a9bf;
`;

const BurgerMenu = styled.div`
  position: absolute;
  z-index: 100;
  right: 0px;
  top: 6.5vh;
  right: 10vw;
  display: none;
  flex-direction: column;
  flex-direction: center;
  align-items: center;
  gap: 5px;

  @media screen and (max-width: 984px) {
    display: flex;
  }
`;

const Meat = styled.div`
  height: 4px;
  border-radius: 5px;
  width: 50px;
  background-color: white;
`;

const BulrryBackground = styled.div`
  position: absolute;
  right: 0;
  z-index: 20;
  top: 15vh;
  background: rgba(135, 169, 191, 0.42);
  backdrop-filter: blur(2px);
  width: 100%;
  height: 100%;
`;

export default SideMenu;
